"use client";

import { use } from "react";

import { cn } from "@shared/lib/style";
import type { getHome } from "@shared/services/home";
import { BaseImage } from "@shared/ui/base-image";

interface MainBannerProps {
  promise: ReturnType<typeof getHome>;
}

export function MainBanner({ promise }: MainBannerProps) {
  const res = use(promise);
  const { mobileImageUrl, imageUrl } = res.data?.banner?.[0] ?? {};

  if (!imageUrl) return null;

  return (
    <section
      className={cn(
        "flex justify-center",
        "min-w-7xl mx-auto h-[600px] max-w-7xl pt-14",
        "max-sm:h-[350px] max-sm:min-w-full",
        "relative",
      )}
    >
      <picture>
        <source
          media="(max-width: 680px)"
          srcSet={mobileImageUrl}
          type="image/webp"
        />
        <source
          media="(max-width: 680px)"
          srcSet={mobileImageUrl}
          type="image/png"
        />
        <BaseImage
          alt=""
          className="h-full object-cover object-top"
          height={600}
          preload
          src={imageUrl}
          width={1280}
        />
      </picture>
      <div className="absolute left-0 top-0 flex size-full items-center justify-center pt-14">
        <h1
          className={cn(
            "text-[80px] font-bold text-white",
            "max-sm:whitespace-pre max-sm:text-[40px]",
          )}
        >
          Seoul Moment
        </h1>
      </div>
    </section>
  );
}
